/**
 * @param {string} tag
 * @param {Element} defaultParent
 * @return {Function}
 */
function createLoader(tag, defaultParent) {
    return (url, options = {}) => new Promise((resolve, reject) => {
        const element = document.createElement(tag);
        const parent = options.parent ?? defaultParent;

        if (options.id) {
            element.id = options.id;
        }

        element.onload = () => {
            resolve(url);
        };

        element.onerror = (message, path, line, column, error) => {
            reject(error);
        };

        if (element instanceof HTMLScriptElement) {
            element.async = true;
            element.src = url;
        }

        if (element instanceof HTMLLinkElement) {
            element.type = 'text/css';
            element.rel = 'stylesheet';
            element.href = url;
        }

        parent.appendChild(element);
    });
}

const typeLoader = {
    js: createLoader('script', document.head),
    css: createLoader('link', document.head),
};

/**
 * @param {string} filename
 * @return {string}
 */
function getLoadableExtension(filename) {
    const types = Object.keys(typeLoader);
    const match = filename.match(new RegExp(`\\.(${types.join('|')})$`));
    return match?.[1];
}

/**
 * @param {string} filename
 * @return {undefined|Function}
 */
function findLoader(filename) {
    const type = getLoadableExtension(filename);
    if (type) {
        return typeLoader[type];
    }

    return undefined;
}

export default {
    ...typeLoader,
    any(url, options = {}) {
        const loader = findLoader(url);

        if (!loader) {
            throw new Error(`No loader for file: ${url}`);
        }

        return loader(url, options);
    },
};
